import React from 'react'

import NavigationBar from "./NavigationBar"
import Hero from "./Hero"

function Header() {
    return (
        <section id="header">
            <NavigationBar />
            <Hero />
        </section>
    )
}

export default Header
